import '../App.css';
import { Link, useLocation } from 'react-router-dom';
import Layout from "../components/Layout";

function GameOver() {
    const location = useLocation();
    const numPoints = location.state?.numPoints ?? 0;

    return (
        <Layout>
            <h1 className="display-title">Time's Up!</h1>

            <div className="panel anim-pop">
                <span className="badge badge-coral">🐒 Round Over</span>

                <div className="final-score">
                    <span className="final-score-value">{numPoints}</span>
                    <span className="final-score-label">Bananas</span>
                </div>

                <p className="hint">
                    {numPoints > 0
                        ? "Nice climbing! Think you can beat that run?"
                        : "Every top monkey starts at the bottom of the tree."}
                </p>

                <div className="btn-row">
                    <Link className="btn btn-xl" to="/play">Play Again</Link>
                    <Link className="btn btn-leaf" to="/leaderboard">Leaderboard</Link>
                </div>
            </div>

            <Link className="btn btn-coral" to="/">Back to the Treehouse</Link>
        </Layout>
    );
}

export default GameOver;
